<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Filtrele</h3>
      </div>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="2" sm="5">
            <b-form-datepicker
              id="datepickerbaslangic"
              v-model="datepickerbaslangic"
              local="en"
              today-variant="danger"
              :placeholder="placeholderbaslangic"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }"
            />
          </b-col>
          <b-col lg="2" sm="5">
            <b-form-datepicker
              id="datepickerbitis"
              v-model="datepickerbitis"
              :placeholder="placeholderbitis"
              local="en"
              today-variant="danger"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }"
            />
          </b-col>
          <b-col lg="2" sm="5">
            <v-select
              v-model="secilenIrsaliyeTur"
              :options="irsaliyeOptions"
              label="name"
              placeholder="Satınalma İrsaliyesi"
              style=""
            >
            </v-select>
          </b-col>
          <b-col lg="2" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="listeleTop"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col lg="2" sm="5">
            <v-select
              v-model="secilenDurum"
              :options="durumOptions"
              label="name"
              placeholder="Aktif"
              style=""
            >
            </v-select>
          </b-col>

          <b-col>
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              size=""
              @click="getMalKabulList()"
              >Listele</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>




    <vs-card style="height: 500px">
      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="malKabulListColumns"
        :rowData="malKabulListesi"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :rowSelection="rowSelection"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import moment from "moment";
import MalKabulDetayButton from "../components/crm-components/kalite-yonetimi/MalKabulDetayButton.vue";
import malKabulKaliteDurumRenderer from "./CellRenderers/malKabulKaliteDurumRenderer.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
export default {
  data() {
    return {
      weekday: 1,
      malKabulListColumns: null,
      rowSelection: null,
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      secilenDurum: "",
      durumOptions: [
        { name: "Aktif", value: "2" },
        { name: "Pasif", value: "3" }
      ],
      arananDeger: "",
      secilenIrsaliyeTur: "",

      irsaliyeOptions: [
        { name: "Satınalma İrsaliyesi", value: "202" },
        { name: "Satış İade İrsaliyesi", value: "120" }
      ],
      datepickerbaslangic: "",
      placeholderbaslangic: "",
      placeholderbitis: "",
      datepickerbitis: "",

      malKabulListesi: []
    };
  },
  components: {
    TextGorunumCellRenderer,
    malKabulKaliteDurumRenderer,
    AgGridVue,
    "v-select": vSelect,
    MalKabulDetayButton
  },
  created() {
    var iddddd = localStorage.getItem("tokenId");

    this.rowSelection = "single";
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getMalKabulList();
    },
    getLastDays() {
      var d = new Date();
      d.setDate(d.getDay() - 14);
      return new Date(d);
    },
    getNow() {
      const today = new Date();
      let dateDeger = today.getMonth() + 1;
      const date =
        today.getDate() + "." + dateDeger + "." + today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getMalKabulList() {
      var vm = this;
      const vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45
      });
      var bitis, baslangic;
      if (vm.datepickerbaslangic == "") {
        var baslangic2 = vm.getLastDays();
        baslangic = moment(String(baslangic2)).format("DD.MM.YYYY");
        vm.placeholderbaslangic = moment(String(baslangic2)).format(
          "DD.MM.YYYY"
        );
      } else {
        baslangic = moment(String(vm.datepickerbaslangic)).format("DD.MM.YYYY");
        vm.placeholderbaslangic = moment(String(baslangic)).format(
          "DD.MM.YYYY"
        );
      }

      if (vm.datepickerbitis == "") {
        bitis = vm.getNow();
        vm.placeholderbitis = bitis;
      } else {
        bitis = moment(String(vm.datepickerbitis)).format("DD.MM.YYYY");
        vm.placeholderbaslangic = moment(String(bitis)).format("DD.MM.YYYY");
      }

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        IlkTarih: baslangic,
        SonTarih: bitis,
        tur:
          typeof vm.secilenIrsaliyeTur.value == "undefined"
            ? "202"
            : vm.secilenIrsaliyeTur.value,
        durum:
          typeof vm.secilenDurum.value == "undefined"
            ? "2"
            : vm.secilenDurum.value,
        aranan: vm.arananDeger
      };
      soap.createClient(url, function(err, client) {
        client.INT_MAL_KABUL_LIST(args, function(err, result) {
          if (result.INT_MAL_KABUL_LISTResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_MAL_KABUL_LISTResult);
            vm.malKabulListesi = JSON.parse(vm.veriler.jsonData);
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    }
  },
  beforeMount() {
    this.malKabulListColumns = [
      {
        width: 150,
        field: "",
        cellRendererFramework: "MalKabulDetayButton"
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200
      },
      {
        headerName: "Sipariş No",
        field: "DOCUMENTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Tarih",
        field: "TARIH",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Ürün Sayısı",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "ADET",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Kabul",
        field: "KABUL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Şartlı Kabul",
        field: "SKABUL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "İade",
        field: "IADE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Ayıkla",
        field: "AYIKLA",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },

      {
        headerName: "Kalite Durumu",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "malKabulKaliteDurumRenderer",
        filterParams: { buttons: ["apply", "reset"] },
        wrapText: true,
        autoHeight: true
      }
    ];
  }
};
</script>
